/**
 * The safety check's stop survives a revisit in the same tab (owner ruling Q4,
 * 2026-10-21), so a panicked repeat visit lands on the stop again rather than
 * on a fresh form. The flag holds no personal data (it is only "stopped"),
 * which is why sessionStorage is acceptable here when `patientSession`
 * deliberately avoids it. It is the only thing Transport keeps in storage: the
 * booking itself lives in memory (M39-Q3).
 */
export const STOP_KEY = 'medcor.transport.stopped'

export function readStopped(): boolean {
  try {
    return window.sessionStorage.getItem(STOP_KEY) === '1'
  } catch {
    return false
  }
}

export function writeStopped(on: boolean): void {
  try {
    if (on) window.sessionStorage.setItem(STOP_KEY, '1')
    else window.sessionStorage.removeItem(STOP_KEY)
  } catch {
    // Storage blocked or full: the stop still holds for this page's lifetime.
  }
}
